import { useSelector } from "react-redux";
// import { getPopulationRate, getThemeSelectedValue } from "../../../reducer/morbidityRateSlice";
import { Grid, Typography } from "@mui/material";

const theme = [{
    color: "#41A30D",
    label: "0"
},{
    color: "#FFCE38",
    label: "≤ 10"
},{
    color: "#EF6A23",
    label: "≤ 50"
},{
    color: "#D92405",
    label: "> 50"
}]
const icons = [{
    icon: "home.png",
    label: "หมู่บ้าน/ชุมชน"
}]
function HILegend(props) {
    // const themeMorbidity = useSelector(getThemeSelectedValue);
    // const populationValue = useSelector(getPopulationRate);

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    HI
                </Typography>
                <Grid container spacing={1}>
                    {
                        icons.map((data, index) => {
                            return (
                                <Grid key={index} container item xs={6}>
                                    <Grid item xs={3} sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <img alt="candice" src={`/images/markers/${data.icon}`} />
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography sx={{
                                            fontSize: 10,
                                            paddingLeft: '5px',
                                            textAlign: 'left',
                                            marginTop: '5px',
                                            fontWeight: '400',
                                        }}>
                                            {data.label}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Grid>
                <Grid container spacing={0}>
                {
                    theme.map((data, index) => {
                        return (
                            <Grid key={index} item xs={(12/theme.length)}>
                                <div style={{
                                    height: 20,
                                    backgroundColor: data.color,
                                    marginTop: '5px'
                                }}></div>
                                <Typography sx={{
                                    fontSize: 10,
                                    textAlign: 'center',
                                    marginTop: '5px',
                                    fontWeight: '400',
                                }}>
                                    {data.label}
                                </Typography>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </div>
        </>
    )
}

export default HILegend;